import { render, staticRenderFns } from "./OrganisationGeneral.vue?vue&type=template&id=601606f6&scoped=true&"
import script from "./OrganisationGeneral.vue?vue&type=script&lang=js&"
export * from "./OrganisationGeneral.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationGeneral.vue?vue&type=style&index=0&id=601606f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601606f6",
  null
  
)

export default component.exports